<template>
  <div class="voorwaarden-container">
    <a
      href="https://customerservice.vtm.be/hc/nl/sections/360003568737-Kraak-de-Code-van-Coppens"
      target="_blank"
      rel="noopener noreferrer"
      >Veelgestelde vragen</a
    >
    -
    <a
      href="https://vtm.be/code-van-coppens/wedstrijdreglement-kraak-de-code-van-coppens-in-hln"
      target="_blank"
      rel="noopener noreferrer"
      >Actievoorwaarden</a
    >
  </div>
</template>
<script>
export default {
  name: 'Voorwaarden',
};
</script>
<style scoped lang="scss">
.voorwaarden-container {
  margin-top: 40px;
  font-size: 14px;

  a {
    padding: 0 5px;
  }
}
</style>
